import createBreakpoint from 'shared-tokens/utils/breakpoints';
import getExtPath from 'shared-utils/src/getExtPath';

export const mainCls = 'fake-qrcode';

export default {
  [`${mainCls}`]:{

  },
  [`${mainCls}__loader-cnt`]: {
    backgroundImage: `url(${getExtPath('common_images/common/qrcode-casait.svg')})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    opacity: '0.15',
  },
  [`${mainCls}__spinner_cnt`]: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  [`${mainCls}__spinner_img`]: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    width:'100%',
  },
};